import Icon from "./img/icon.svg";
import "./style.scss";

const AB_2771 = ({
    value = "",
    onChange = () => {},
    className = "",
    error = "",
    placeholder = "",
    suggestEmailValue,
    handleClickSuggest,
    onClick,
    autoComplete = "off",
    showIcon = true,
    ref,
    id,
    setTriggerIcon = () => {},
    icon = Icon,
    setInputFieldsState = () => {},
    setSuggestEmailValue = () => {},
    autoFocus = false,
}) => {
    const regex = new RegExp(`^@${(value.match(/@(.*)/)?.[1] || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`, "i");
    const newSuggestEmail = !value.includes("@") ? suggestEmail : suggestEmail.filter((i) => regex.test(i.sug));

    return (
        <div className={`ab-2771 input-text-ui${value.length > 0 ? " input-text-ui_filled" : ""}${error ? " input-text-ui_error" : ""} ${className}`}>
            <div className="input-text-ui__group">
                <div className="input-text-ui__field-wrap">
                    <input
                        ref={ref}
                        value={value}
                        onChange={onChange}
                        className="input-text-ui__input"
                        type="text"
                        onClick={onClick}
                        autoFocus={autoFocus}
                        autoComplete={autoComplete}
                        id={id}
                        onBlur={(e) => {
                            if (e.target.value.length === 0) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 0 };
                                });
                            }
                        }}
                        onFocus={(e) => {
                            if (e.target.value.length === 0) {
                                setTriggerIcon((prev) => {
                                    return { ...prev, [id]: 1 };
                                });
                            }
                        }}
                    />

                    <label htmlFor={id} className="input-text-ui__float">
                        {placeholder}
                    </label>
                </div>

                {suggestEmailValue && newSuggestEmail.length > 0 && (
                    <div className="input-text-ui__suggest">
                        {newSuggestEmail.map((it, idx) => (
                            <span className="input-text-ui__suggest-item" key={idx} onClick={() => handleClickSuggest(it.sug, value)}>
                                {value.split("@")[0]}
                                {it.sug}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

const suggestEmail = [
    { sug: "@yandex.ru" },
    { sug: "@mail.ru" },
    { sug: "@gmail.com" },
    { sug: "@bk.ru" },
    { sug: "@inbox.ru" },
    { sug: "@list.ru" },
    { sug: "@rambler.ru" },
    { sug: "@yahoo.com" },
    { sug: "@outlook.com" },
    { sug: "@icloud.com" },
    { sug: "@ya.ru" },
    { sug: "@proton.me" },
    { sug: "@live.ru" },
    { sug: "@msn.com" },
    { sug: "@meta.ua" },
];

export default AB_2771;
